import type { ValidateAddressResponse } from '../../../core/models/address-validate';

type AddressNotFoundSectionKey = 'shipFrom' | 'shipTo' | 'returnAddress';

/**
 * Identifies sections that must hard-block on address-not-found without a correction panel.
 * OM-513: invalid AVS results without an actionable suggestion are handled via the suggestion
 * panel (typed-address backfill + Keep My Entry), so this mapper no longer flags those cases.
 */
export function mapValidateResultsToAddressErrors(
  _response: ValidateAddressResponse,
): AddressNotFoundSectionKey[] {
  return [];
}
